var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9996 12.113C39.0821 12.113 12.4326 39.3682 12.4326 72.68C12.4326 105.992 39.6878 133.247 72.9996 133.247C106.311 133.247 133.567 105.992 133.567 72.68C133.567 39.3682 106.311 12.113 72.9996 12.113ZM72.9996 121.134C46.3501 121.134 24.546 99.3295 24.546 72.68C24.546 46.0306 46.3501 24.2264 72.9996 24.2264C99.6491 24.2264 121.453 46.0306 121.453 72.68C121.453 99.3295 99.6491 121.134 72.9996 121.134Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6208 71.4695L63.9146 52.6937C62.7032 52.088 60.8862 52.6937 60.8862 54.5107V91.4566C60.8862 92.6679 62.7032 93.8792 63.9146 93.2796L96.6208 74.4978C97.8321 73.8921 97.8321 72.0751 96.6208 71.4695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.0e5e4bbb8c9df799bfd3f586167553f1.svg";
export { ForwardRef as ReactComponent };